angular.module('charts')
  .directive('standardsGrid', function() {
    return {
      restrict: 'E',
      scope: {
        gridData: '=',
        grades: '='
      },
      templateUrl: '/resources/charts/partials/standards-grid.html',
      controller: ['$scope', 'configuration', 'customer', function($scope, dblConfigurationService, dblCustomerService) {

        $scope.newContentSupportUrl = dblConfigurationService.getConstant('new_content_support_url');
        $scope.newLessonsConfigValue = dblConfigurationService.getConstant('standards_with_new_lessons');
        $scope.customerStandard = dblCustomerService.getAcademicStandard().academic_standard_name;

      }]
    };
  });
